import { render, staticRenderFns } from "./EditReply.vue?vue&type=template&id=1d56cc0e&"
import script from "./EditReply.vue?vue&type=script&lang=js&"
export * from "./EditReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports